import { createContext } from 'react';

export const AdminDashboardContext = createContext("");